import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-lightShow" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "space-y-4 p-4" }
const _hoisted_4 = { class: "whitespace-pre-wrap" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 border-black text-left py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium" }, "ブランド詳細")
], -1)
const _hoisted_6 = { class: "py-4 text-left" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "whitespace-pre-wrap" }
const _hoisted_9 = { class: "border-b-2 border-black text-left py-2" }
const _hoisted_10 = { class: "text-sm font-medium" }
const _hoisted_11 = { class: "py-4 text-left flex flex-wrap" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "text-left mt-1" }
const _hoisted_15 = { class: "text-sm font-medium h-10 line-clamp-2" }
const _hoisted_16 = {
  key: 0,
  class: "text-base font-medium"
}
const _hoisted_17 = { class: "space-x-2 text-sm font-medium" }
const _hoisted_18 = {
  key: 0,
  class: "text-gray-400 line-through"
}
const _hoisted_19 = {
  key: 1,
  class: "text-green-lightShow font-medium"
}
const _hoisted_20 = { class: "py-4 flex justify-center" }
const _hoisted_21 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.shop.imageUrl,
      alt: "",
      class: "aspect-square w-full object-cover"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.shop.description), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.shop.name) + "の特別優待", 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vouchers, (voucher) => {
            return (_openBlock(), _createElementBlock("div", {
              key: voucher.voucherId,
              class: "w-1/2 p-2",
              onClick: ($event: any) => (_ctx.goVoucherDetail(voucher.voucherId))
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: 
                  voucher.images[0].imageUrl ||
                  require('@/assets/images/no_image.png')
                ,
                  alt: "",
                  class: "aspect-square w-full object-cover"
                }, null, 8, _hoisted_13)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, _toDisplayString(voucher.name), 1),
                _createElementVNode("div", null, [
                  (
                    !!voucher.discountedPrice || voucher.discountedPrice === 0
                  )
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, " ￥" + _toDisplayString(voucher.discountedPrice.toLocaleString()), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_17, [
                    (voucher.price != 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, " ￥" + _toDisplayString(voucher.price.toLocaleString()), 1))
                      : _createCommentVNode("", true),
                    (
                      voucher.discountType === _ctx.DiscountTypes.Amount ||
                      voucher.discountType === _ctx.DiscountTypes.Rate
                    )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(voucher.discountValue.toLocaleString()) + " " + _toDisplayString(_ctx.SuffixDiscountValueLabels[voucher.discountType]), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 8, _hoisted_12))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("a", {
          href: _ctx.shop.specifiedCommercialTransactionsUrl,
          class: "underline text-sky-400 hover:text-sky-800"
        }, " このショップの特定商取引法に基づく表記 ", 8, _hoisted_21)
      ])
    ])
  ]))
}